import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import IndexPage from '@/components/IndexPage.vue'
import DashboardLogin from '@/components/DashboardLogin.vue'
import ForgotPassword from '@/components/ForgotPassword.vue'
import ResetPassword from '@/components/ResetPassword.vue'
import PageEdit from '@/components/PageEdit.vue'
import ParserManual from '@/components/ParserManual.vue'
import CSRMenu from '@/components/CSRMenu.vue'
import RightSideBar from '@/components/RightSideBar.vue'
import ColorSchemePage from '@/components/ColorSchemePage.vue'
import SettingsFontsPage from '@/components/SettingsFontsPage.vue'
import SettingsSocialMedia from '@/components/SettingsSocialMedia.vue'
import MediaGallery from '@/components/MediaGallery.vue'
import SettingsGlobal from '@/components/SettingsGlobal.vue'
import VisitorActivity from '@/components/VisitorActivity.vue'
import SnapshotList from '@/components/SnapshotList.vue'
import EmailSystem from '@/components/EmailSystem.vue'
import ResetUserPassword from '@/components/ResetUserPassword.vue'
import SecondaryDomains from '@/components/SecondaryDomains.vue'
import RobotsTxt from '@/components/RobotsTxt.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/login/:sb?',
    name: 'DashboardLogin',
    component: DashboardLogin,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '/reset-password/:resetToken',
    name: 'ResetPassword',
    component: ResetPassword,
    // encodeURIcomponent: true,
  },
  {
    path: '/',
    name: 'IndexPage',
    component: IndexPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/pages/:id',
    name: 'PageEdit',
    component: PageEdit,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/csr-menu',
    name: 'CSRMenu',
    component: CSRMenu,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/right-sidebar',
    name: 'RightSideBar',
    component: RightSideBar,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/color-scheme',
    name: 'ColorSchemePage',
    component: ColorSchemePage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings-fonts',
    name: 'SettingsFontsPage',
    component: SettingsFontsPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings-social-media',
    name: 'SettingsSocialMedia',
    component: SettingsSocialMedia,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/media-gallery',
    name: 'PhotosAndImages',
    component: MediaGallery,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings-global',
    name: 'SettingsGlobal',
    component: SettingsGlobal,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/visitor-activity',
    name: 'VisitorActivity',
    component: VisitorActivity,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/parser',
    name: 'ParserManual',
    component: ParserManual,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/snapshot-list',
    name: 'SnapshotList',
    component: SnapshotList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/email-system',
    name: 'EmailSystem',
    component: EmailSystem,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/reset-user-password',
    name: 'ResetUserPassword',
    component: ResetUserPassword,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/secondary-domains',
    name: 'SecondaryDomains',
    component: SecondaryDomains,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/domain-robots',
    name: 'RobotsTxt',
    component: RobotsTxt,
    meta: {
      requiresAuth: true,
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isLoggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
